import React, {useContext} from "react";
import "./LabExperience.scss";
import {labExperienceSection} from "../../portfolio";
import StyleContext from "../../contexts/StyleContext";
import {Fade} from "react-reveal";

function LabExperience() {
  const {isDark} = useContext(StyleContext);
  if (!labExperienceSection.display) return null;

  return (
    <Fade bottom duration={500} distance="10px">
      <div id="lab-experience" className="main lab-experience">
        <h1 className={isDark ? "dark-mode heading lab-experience-heading" : "heading lab-experience-heading"}>
          {labExperienceSection.title}
        </h1>
      <div className="lab-experience-cards">
        {labExperienceSection.experiences.map((exp, index) => (
          <div key={index} className="lab-experience-card">
            <img
              src={exp.image}
              alt={exp.title}
              className="lab-experience-image"
            />
            <div className="lab-experience-content">
                <h2 className={isDark ? "dark-mode lab-experience-card-title" : "lab-experience-card-title"}>
                  {exp.title}
                </h2>
                <p className={isDark ? "dark-mode lab-experience-description" : "lab-experience-description"}>
                  {exp.description}
                </p>
            </div>
          </div>
        ))}
      </div>
    </div>
    </Fade>
  );
}

export default LabExperience;
